<template>
  <div class="key-stats d-flex flex-row justify-content-start flex-wrap" v-if="Array.isArray(items) && items.length">
    <div class="d-flex flex-row align-items-center mb-2 mr-4" v-for="({ icon, label, value }, i) in items" :key="i">
      <font-awesome-icon class="text-primary-a5 mr-2" v-if="icon" :icon="icon" :size="iconSize"/>
      <div class="d-flex flex-column">
        <span class="d-block text-secondary-a5" v-if="!hideLabels && label">{{label}}</span>
        <span class="d-block text-secondary-a8" :class="{ 'font-weight-bold': !hideLabels && label }">{{value}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import _isPlainObject from 'lodash/isPlainObject';
import { mapRoot } from '@/mixins/root';

export default {
  props: {
    job: {
      type: Object,
      required: true,
    },
    iconSize: {
      type: String,
      default: '2x',
    },
    includeType: {
      type: Boolean,
      default: false,
    },
    hideLabels: {
      type: Boolean,
      default: false,
    },
    hideReferralBonus: {
      type: Boolean,
      default: false,
    },
    isPublic: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapRoot([ 'company', 'isNielsenIQ' ]),
    items() {
      const items = [];

      if (this.includeType) {
        items.push({
          icon: 'briefcase',
          value: 'Job',
        });
      }

      if (this.job && this.job.department && this.job.department.name) {
        items.push({
          icon: this.job.department.icon || 'users',
          label: this.$t('jobs.key-stats.department'),
          value: this.job.department.name,
        });
      } else if (this.getCustomValue('department')) {
        items.push({
          icon: 'users',
          label: this.$t('jobs.key-stats.department'),
          value: this.getCustomValue('department'),
        });
      }

      if (this.getCustomValue('location')) {
        items.push({
          icon: 'map-marker',
          label: this.$t('jobs.key-stats.location'),
          value: this.getCustomValue('location'),
        });
      } else if (this.job && this.job.location && this.job.location.name) {
        items.push({
          icon: 'map-marker',
          label: this.$t('jobs.key-stats.location'),
          value: this.job.location.name,
        });
      }

      if (this.getCustomValue('roleType')) {
        items.push({
          icon: 'tag',
          label: this.$t('jobs.key-stats.roleType'),
          value: this.getCustomValue('roleType'),
        });
      } else if (this.getCustomValue('role-type')) {
        items.push({
          icon: 'tag',
          label: this.$t('jobs.key-stats.roleType'),
          value: this.getCustomValue('role-type'),
        });
      }

      if (this.getCustomValue('requisitionID')) {
        items.push({
          icon: 'tag',
          label: 'Requisition ID',
          value: this.getCustomValue('requisitionID'),
        });
      }

      if (this.getCustomValue('workplace')) {
        items.push({
          icon: 'tag',
          label: this.$t('jobs.labels.workplace'),
          value: this.getCustomValue('workplace'),
        });
      }

      if (this.job && this.job.industry && !this.isNielsenIQ) {
        items.push({
          icon: 'industry',
          label: this.$t('jobs.key-stats.industry'),
          value: this.job.industry,
        });
      } else if (this.getCustomValue('industry') && !this.isNielsenIQ) {
        items.push({
          icon: 'industry',
          label: this.$t('jobs.key-stats.industry'),
          value: this.getCustomValue('industry'),
        });
      }

      if (this.getCustomValue('brands')) {
        items.push({
          icon: 'tag',
          label: this.$t('jobs.labels.brand'),
          value: this.getCustomValue('brands'),
        });
      }

      if (this.getCustomValue('company') && !this.isNielsenIQ) {
        items.push({
          icon: 'tag',
          label: this.$t('jobs.labels.company'),
          value: this.getCustomValue('company'),
        });
      }

      if (this.getCustomValue('datePosted')) {
        items.push({
          icon: 'tag',
          label: this.$t('jobs.labels.datePosted'),
          value: (new Date(this.getCustomValue('datePosted'))).toLocaleString().split(/[ ,T]/)[0]
        });
      }

      if (this.hideReferralBonus === false && this.isPublic === false) {
        const { sitePreferences: { jobReferralBonusDefault } } = this.company;
        if (this.job && this.job.referralBonus) {
          items.push({
            icon: 'gift',
            label: this.$t('jobs.key-stats.referralBonus'),
            value: this.job.referralBonus,
          });
        } else if (this.getCustomValue('referralBonus')) {
          items.push({
            icon: 'gift',
            label: this.$t('jobs.key-stats.referralBonus'),
            value: this.getCustomValue('referralBonus'),
          });
        } else if (jobReferralBonusDefault) {
          items.push({
            icon: 'gift',
            label: this.$t('jobs.key-stats.referralBonus'),
            value: jobReferralBonusDefault,
          });
        }
      }

      if (this.job && this.job.pointsMultiplier && this.isPublic === false) {
        items.push({
          icon: 'award',
          label: 'Promotion',
          value: `X${this.job.pointsMultiplier} points`,
        });
      }

      return items;
    },
  },
  methods: {
    getCustomValue(key) {
      if (this.job && _isPlainObject(this.job.customFieldsHash)) {
        return this.job.customFieldsHash[key] || null;
      } else if (this.job && Array.isArray(this.job.customFields)) {
        return (this.job.customFields.find(cf => cf && cf.key === key) || {}).value;
      } else {
        return null;
      }
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/jobs/key-stats.vue